import type { RouteRecordRaw } from 'vue-router'
import { ChatIcon } from '@/components/icons'

export const ChatRoutes: Array<RouteRecordRaw> = [
  {
    path: '/chat',
    meta: { middleware: 'auth', requiresPlanAccess: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: '',
        name: 'chat-app',
        component: () => import('@/views/user-chat/index.vue'),
        meta: {
          breadcrumb: [{ text: 'چت', to: '/chat', icon: ChatIcon }]
        }
      }
    ]
  }
]
